import { isEmpty } from 'lodash';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { VehicleQualification } from '../model/departure';
import { RequestCriteria } from 'src/app/shared/model/request-criteria';
import { Operator } from 'src/app/shared/model/operator';

export const qualificationToTranslateKey = (value: VehicleQualification): string => {
  switch (value) {
    case (VehicleQualification.PRIMARY): return 'sakp.common.enums.vehicle-qualification.PRIMARY';
    case (VehicleQualification.REPLACEMENT): return 'sakp.common.enums.vehicle-qualification.REPLACEMENT';
    case (VehicleQualification.INVALID): return 'sakp.common.enums.vehicle-qualification.INVALID';
  }
};

export const getRate = (rate: number): string => `💰 ${rate}%`;

export const interrobangIfEmptyOrMatch = (value: string, unmatch: string[] = []): string =>
                                            value == null || isEmpty(value) || unmatch.includes(value) ? '⁉️' : value;

export const checkIsSameDay = (day1: Date, day2: Date): boolean =>
  day1?.getFullYear() === day2?.getFullYear() && day1?.getMonth() === day2?.getMonth() && day1?.getDate() === day2?.getDate();

export const makeZeroTime = (date: Date): Date => {
    date?.setHours(0);
    date?.setMinutes(0);
    date?.setSeconds(0);
    date?.setMilliseconds(0);
    return date;
};

const dayQueryParam = 'day';
const dayQueryParamFormat = 'YYYY-MM-DD';

/**
 * maxDay pozwala odrzucić dzień, którego dany widok nie dopuszcza - podwidoki mają różne limity
 * (specyfikacje pojazdów pozwalają na przyszłość, rejestr nie), a dzień wędruje między nimi w URL.
 * Bez tego nagłówek pokazywałby dzień z URL-a, a kalendarz odrzuciłby go i pokazał dzisiaj.
 */
export function dayFromUrl(route: ActivatedRoute, maxDay?: Date): Date {
  const parsed = moment(route.snapshot.queryParamMap.get(dayQueryParam), dayQueryParamFormat, true);
  if (!parsed.isValid() || (maxDay && parsed.isAfter(moment(maxDay), 'day')))
    return null;
  return makeZeroTime(parsed.toDate());
}

export function putDayInUrl(router: Router, route: ActivatedRoute, day: Date): void {
  const value = moment(day).format(dayQueryParamFormat);
  if (route.snapshot.queryParamMap.get(dayQueryParam) === value)
    return;
  void router.navigate([], {
    relativeTo: route,
    queryParams: { [dayQueryParam]: value },
    queryParamsHandling: 'merge',
    replaceUrl: true
  });
}

export function createDayCriteria(day: Date): RequestCriteria {
  return {
    operator: Operator.and,
    criteria: [{
      operator: Operator.equals,
      fieldName: 'day',
      value: day.toDateString()
    }]
  };
}
